import { version } from '@environments/version';

export const environment = {
  PRODUCTION: true,
  APP_VERSION: version,
  STAGE: 'development',

  CACHE_LIFETIME: 300000,
  NOTIFICATIONS_CACHE_LIFETIME: 20000,
  SESSION_ACTIVITY_MINUTES: 360,

  // PORTAL_API for Notification and Identity
  PORTAL_API: 'https://stg.api.portal.cxc.com.mx',
  // FACILITIES_API for Operations
  FACILITIES_API: 'https://dev.api.suite.cxc.com.mx',
  COMPANIES_API: 'https://dev.api.suite.cxc.com.mx',

  FACILITIES_API_KEY: 'zxYwS0rM9tUvP1qR8oN7mJ2iL3kH4gFeDcB',
  FINANCIALS_API_KEY: 'zxYwS0rM9tUvP1qR8oN7mJ2iL3kH4gFeDcB',
  COMPANIES_API_KEY: 'zxYwS0rM9tUvP1qR8oN7mJ2iL3kH4gFeDcB',
  DATA_STUDIO_API_KEY: 'zxYwS0rM9tUvP1qR8oN7mJ2iL3kH4gFeDcB',
  // LEN-2764: false once this environment's load balancer enforces the
  // JWT-shaped Bearer rule (920); then the browser stops sending the key.
  SEND_EDGE_API_KEY: true,

  REMOTE_URL_RUG: 'https://dev.rug.suite.cxc.com.mx',
  REMOTE_URL_AIVA: 'https://aiva-ui-dev.web.app',
  REMOTE_URL_COMPANY: 'https://dev.companies.suite.cxc.com.mx',
  REMOTE_URL_FINANCIAL: 'https://dev.financials.suite.cxc.com.mx',
  REMOTE_URL_DATA_STUDIO: 'https://dev.data-studio.suite.cxc.com.mx',
  REMOTE_URL_SHELL_ADMIN: 'https://dev.shell-admin.suite.cxc.com.mx',
  // Embedded DocFlow AI. Must be served without IAP (LEN-2400) or the iframe falls back to "not available"
  DOCFLOW_URL: 'https://dev.docflow.ai.cxc.com.mx/',

  SENTRY_DSN:
    'https://5066bcb22a8b89236353618dfb9ba751@o4504160456474624.ingest.us.sentry.io/4509158904758272',

  PENDO_API_KEY: '2322acbd-8edd-49d0-a34b-7013baf148c3',
  PENDO_ENV: 'io',
  PENDO_DEBUG: false,
  ENABLE_PENDO: true,
};
